export default "__VITE_PUBLIC_ASSET__eca9c94c__"